import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAdddishMaster } from "../../store/adddish/reducer";
import { REQUEST_DELETE_MASTER_ADDDISH } from "../../store/adddish/adddishActionTypes";
interface DishDeleteProps {
  event: any;
  isOpen: boolean;
  onClose: () => void;
}

const DishDeleteConfirmation: React.FC<DishDeleteProps> = ({
  isOpen,
  onClose,
  event,
}) => {
  const dispatch = useDispatch();
  const { masterAdddish: events, busy, message } = useAdddishMaster();

  const toast = useToast();

  useEffect(() => {
    const findEvent = events.find(
      (val: Record<string, any>) => val._id === event._id
    );
    if (!findEvent) {
      toast({
        title: "Success.",
        description: "dish is deleted.",
        status: "success",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [event, events, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Dish</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            {`Are you sure you want to delete this dish?`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_ADDDISH,
                payload: { _id: event._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DishDeleteConfirmation;
